import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import ListFilters from 'components/PendingRefundsList/Filters'
import PendingRefundsList from 'components/PendingRefundsList/List'
import Layout from 'containers/Layout'

import { getCurrentVenueId } from 'store/Venues/selector'
import { fetchRefundOrders } from 'store/Orders/actions'
import { fetchRevenueCenters } from 'store/RevenueCenters/actions'

export const PendingRefunds = () => {
  const dispatch = useDispatch()
  const venueUuid = useSelector(getCurrentVenueId)

  useEffect(() => {
    if (venueUuid) {
      dispatch(fetchRefundOrders(venueUuid))
      dispatch(fetchRevenueCenters(venueUuid))
    }
  }, [venueUuid, dispatch])

  return (
    <Layout
      mainContent={<PendingRefundsList />}
      navbarContent={<ListFilters />}
    />
  )
}

PendingRefunds.propTypes = {}

export default PendingRefunds
